<template>
  <el-dialog
      title="Đổi mật khẩu"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="change-password-dialog"
  >
    <el-form
        class="change-password-form"
        label-width="160px"
        :model="passwordData"
        label-position="left"
        :rules="rules"
        ref="passwordData"
    >
      <div class="change-password-content">
        <div class="password-panel">
          <div class="password-panel-head">
            <div class="panel-icon">
              <i class="el-icon-lock"></i>
            </div>
            <div class="panel-text">
              <p class="panel-title">Cập nhật mật khẩu</p>
              <p class="panel-subtitle">Vui lòng nhập đầy đủ thông tin để đảm bảo an toàn cho tài khoản của bạn.</p>
            </div>
          </div>

          <el-form-item label="Mật khẩu cũ" prop="oldPassword">
            <el-input
                prefix-icon="el-icon-lock"
                v-model="passwordData.oldPassword"
                @keyup.enter.native="submitForm"
                placeholder="Nhập mật khẩu cũ"
                clearable
                show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="Mật khẩu mới" prop="password">
            <el-input
                prefix-icon="el-icon-lock"
                v-model="passwordData.password"
                @keyup.enter.native="submitForm"
                placeholder="Nhập mật khẩu mới"
                clearable
                show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="Xác nhận mật khẩu" prop="confirmPassword">
            <el-input
                prefix-icon="el-icon-lock"
                v-model="passwordData.confirmPassword"
                @keyup.enter.native="submitForm"
                placeholder="Nhập lại mật khẩu mới"
                clearable
                show-password
            ></el-input>
          </el-form-item>

          <div class="password-note">
            <i class="el-icon-info"></i>
            <span>Mật khẩu cần có ít nhất 6 ký tự và nên kết hợp chữ, số để tăng bảo mật.</span>
          </div>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer change-password-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialogByButton">
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
      <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm"
      >
        <i class="el-icon-circle-check"/>
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CredentialService from "@/services/CredentialService";

export default {
  props: {
    dialogVisible: null,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.passwordData.password) {
        callback(new Error("Mật khẩu không khớp"));
      } else {
        callback();
      }
    };
    return {
      passwordData: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      loadingButton: false,
      rules: {
        oldPassword: [
          {
            required: true,
            message: "Mật khẩu cũ không được để trống",
            trigger: "blur",
          },
          {
            min: 6,
            message: "Mật khẩu phải lớn hơn hoặc bằng 6 ký tự",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Mật khẩu mới không được để trống",
            trigger: "blur",
          },
          {
            min: 6,
            message: "Mật khẩu phải lớn hơn hoặc bằng 6 ký tự",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "Xác nhận mật khẩu không được để trống",
            trigger: "blur",
          },
          {
            min: 6,
            message: "Mật khẩu phải lớn hơn hoặc bằng 6 ký tự",
            trigger: "blur",
          },
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs["passwordData"].resetFields();
      }, 300);
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
    },
    resetFormData() {
      this.$refs["passwordData"].resetFields();
    },
    submitForm() {
      this.$refs["passwordData"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          const data = {...this.passwordData}
          CredentialService.changePassword(data)
              .then((resp) => {
                this.$confirm(resp.data.message + '! Xin vui lòng đăng nhập lại', 'Thông báo', {
                  confirmButtonText: 'OK',
                  showCancelButton: false,
                  type: 'success'
                }).then(() => {
                  localStorage.clear();
                  this.$router.push("/login");
                })
                this.closeDialogByButton();
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.change-password-content {
  padding: 4px 0 6px;
}

.password-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
}

.password-panel-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}

.panel-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #60a5fa, #2563eb);
  color: #ffffff;
  font-size: 18px;
  flex-shrink: 0;
}

.panel-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.panel-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.password-note {
  margin-top: 4px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #eff6ff;
  color: #2563eb;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.5;
}

.change-password-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/deep/ .change-password-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .change-password-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/ .change-password-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/ .change-password-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/ .el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

/deep/ .el-form-item__label {
  font-family: Inter, Arial, Helvetica, sans-serif;
  color: #475569;
  font-weight: 600;
}

/deep/ .el-input__inner {
  border-radius: 10px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .btn-cancel,
/deep/ .btn-save {
  min-width: 110px;
  border-radius: 10px;
}
</style>
